export default __webpack_public_path__ + "static/media/person.a203c94c.svg";